<template>
<vs-card class="cardx">
  <div v-if="showA">
    <vs-table :max-items="$store.state.pagination" pagination search :data="box">
    <template slot="thead" class="ps_thead_boxList">
    <vs-th class="ps_tr_boxList" sort-key="name">
        Nombre
    </vs-th>
    <vs-th class="ps_tr_boxList" sort-key="uuid">
        UUID
    </vs-th>
    <vs-th class="ps_tr_boxList" sort-key="api_key">
        Llave Api
    </vs-th>
    <vs-th class="ps_tr_boxList" sort-key="mac">
        MAC
    </vs-th>
    <vs-th class="ps_tr_boxList" sort-key="imei">
        IMEI
    </vs-th>
    <vs-th class="ps_tr_boxList" sort-key="vehicle_id">
        Id De Vehiculo
    </vs-th>
    <vs-th class="ps_tr_boxList" sort-key="pre_register_time">
        Tiempo de Pre-Registro
    </vs-th>
    <vs-th class="ps_tr_boxList" sort-key="register_time">
        Tiempo De Registro
    </vs-th>
    <vs-th class="ps_tr_boxList" sort-key="register_key">
        Llave De Registro
    </vs-th>
    <vs-th class="ps_tr_boxList" sort-key="is_ok">
        Activado
    </vs-th>
    <vs-th class="ps_tr_boxList">
    </vs-th>
    </template>

    <template slot-scope="{data}">
    <vs-tr :style="data[indextr].uuid != null? 'background-color: rgb(0 255 37 / 10%);':data[indextr].uuid == null?'background-color: rgb(41 98 255 / 10%);':'background-color: none'" :key="indextr" v-for="(tr, indextr) in data" >
        <vs-td :data="data[indextr].name">
        {{data[indextr].name}}
        </vs-td>
        <vs-td :data="data[indextr].uuid">
        {{data[indextr].uuid}}
        </vs-td>
        <vs-td :data="data[indextr].api_key">
        {{data[indextr].api_key}}
        </vs-td>
        <vs-td :data="data[indextr].mac">
        {{data[indextr].mac}}
        </vs-td>
        <vs-td :data="data[indextr].imei">
        {{data[indextr].imei}}
        </vs-td>
        <vs-td :data="data[indextr].vehicle_id">
        {{data[indextr].vehicle_id}}
        </vs-td>
        <vs-td :data="data[indextr].pre_register_time">
        {{data[indextr].pre_register_time}}
        </vs-td>
        <vs-td :data="data[indextr].register_time">
        {{data[indextr].register_time}}
        </vs-td>
        <vs-td :data="data[indextr].register_key">
        {{data[indextr].register_key}}
        </vs-td>
        <vs-td v-if="data[indextr].is_ok" :data="data[indextr].is_ok">
          <vs-checkbox class="justify-content-start ps_check" v-model="data[indextr].is_ok" disabled></vs-checkbox>
        </vs-td>
        <vs-td v-if="!data[indextr].is_ok">
        </vs-td>
        <vs-td v-if="data[indextr].uuid" :data="data[indextr].id">
          <vs-button @click="edit(data[indextr].id)" color="darkgreen" type="border" icon="edit">Editar</vs-button>
        </vs-td>
        <vs-td v-if="!data[indextr].uuid" :data="data[indextr].id">
          <vs-button @click="Act(data[indextr].id)" color="darkgreen" type="border" icon="edit">Activar</vs-button>
        </vs-td>
    </vs-tr>
    </template>
    </vs-table>
  </div>
  <div v-if="!showA" class="ps_div_alert">
    <vs-alert class="ps_alert_box_list" title="Information" color="rgb(231, 154, 23)">
            No data to display.
    </vs-alert>
  </div>
  <div>
    <Modal :show="showModal" @close="showModal = false">
      <template #body>
        <BoxEdit v-if="$data.vwEdit" :id="$data.id"></BoxEdit>
        <BoxActivate v-if="$data.vwAct" :id="$data.id"></BoxActivate>
      </template>
    </Modal>
  </div>
</vs-card>
</template>
<script>
import axios from 'axios'
import Modal from './components/utils/Modal'
import BoxEdit from './components/box/BoxEdit.vue';
import BoxActivate from './components/box/BoxActivate.vue';
export default {
    name: "boxList",
    props:{
    },
    components: {
    Modal,
    BoxEdit,
    BoxActivate
},
    data:()=>({
    showModal: false,
    vwEdit: false,
    vwAct: false,
    id: '',
    showA: false,
    box: []
  }),
  methods: {
    scrollInto(elementId) {
      const section = document.querySelector(`#${elementId}`);
      section.scrollIntoView({
        behavior: 'smooth'
      });
    },
    getInfoBoxs(){
      const url_api =  this.$store.state.url_api
      axios.get(url_api + 'api/boxList').then(response => {
        this.box = response.data
        if(response.data.isok === false){
          this.showA = false
        }
        else{
          this.showA = true
          this.recordsOld = response.data
          this.records = this.recordsOld
        }
      })
      .catch((error) => {
        console.error(error)
      })
    },
    edit(id){
      this.vwAct = false
      this.vwEdit = true
      this.showModal = true
      this.id = String(id)
    },
    Act(id){
      this.vwEdit = false
      this.vwAct = true
      this.showModal = true
      this.id = String(id)
    },
  },
  mounted(){
  this.getInfoBoxs()
  },
  watch: {
    showModal: function(val){
      this.getInfoBoxs()
    }
  }
}
</script>
<style>
  .ps_div_alert{
    text-align:center;
  }
  .ps_alert_box_list{
    width: max-content;
    min-width: 300px;
    margin:0px auto;
  }
</style>